module.exports = __webpack_public_path__ + "img/newsImg11-22.6bdba5b6.png";